<template>
  <div class="form-group" v-bind:class="{'disabled': parseBoolean(disabled)}">
    <label v-if="label" class="form-label">{{ label }}
      <i v-if="parseBoolean(required)" class="far fa-asterisk"></i>
      <span v-if="language" class="language"> ({{ language }})</span>
    </label>
    <textarea v-bind:id="id" ref="input" type="text"
              v-bind:value="value" v-bind:placeholder="placeholder"
              v-on:input="updateValue($event.target.value);"
              v-bind:maxlength="maxlength"
              v-bind:rows="rows"
              class="form-control"
              v-bind:class="{'is-invalid': invalid}"
              v-bind:disabled="parseBoolean(disabled)"/>
    <local-errors v-bind:value="errors"/>
    <div v-if="help" class="form-text"><slot></slot></div>
  </div>
</template>

<script>
export default {
  name: "input-textarea",
  computed: {
    help: function () {
      return !!this.$slots.default;
    },
    invalid: function () {
      return this.errors && this.errors.length > 0;
    }
  },
  props: ["id", "value", "errors", "label", "placeholder", "language", "required", "rows", "maxlength", "disabled"],
  methods: {
    updateValue: function (value) {
      this.$emit("input", value);
    }
  }
}
</script>
